import * as React from 'react';
import styles from './LegalAgreementError.module.scss';
import ErrorPage from '../../../components/shared/ErrorPage/ErrorPage';

const LegalAgreementError = () => {
  return (
    <ErrorPage>
      <div className={styles['error-page-message']}>
        The current page didn't load correctly. Please try again later or &nbsp;
        <a
          className={styles['error-page-link']}
          href="javascript: location.pathname = 'personal-investing/tools/pamwebsite'">
          try reloading the page.
        </a>
      </div>
      <div className={styles['sso-form-error-message']}>
        There was a problem on Account Information Agreement. We apologize for
        the inconvenience.
      </div>
    </ErrorPage>
  );
};

export default LegalAgreementError;
